import {
  processLayoutOptions,
  PrimaryCollectionBlockType,
  LayoutOptions,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";
import { ContentCollectionItemType } from "../components/content-collection-item";

export const layoutOptions = {
  ...LayoutOptions.BackgroundColor,
  ...{
    itemBackground: LayoutOptions.Boolean,
  },
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type ContentCollectionType = {
  title?: string;
  description?: string;
  tagline?: string;
  buttonText?: string;
  buttonLink?: string;
  PrimaryBlocks: ContentCollectionItemType[];
} & PrimaryCollectionBlockType<LayoutProps>;
